import req from "@/assets/js/axios"

export default {
  // 查询获奖经历或教育经历
  getFrontExtends: (params) => {
    return req.apiAxios('POST', '/extend/extendController/getFrontExtends', params)
  },
  // 删除获奖经历或教育经历
  deleteFrontExtend: (params) => {
    return req.apiAxios('POST', '/business/extend/BExtendController/whale-security/deleteFrontExtend', params)
  },
}
